import Vue from 'vue'
import Vuex from 'vuex'
import {getCookie} from "../utils/cookies";
import portfolio from './portfolio'
import history from './history'
import orders from './orders'
import balance from './balance'
import trade from './trade'
// import blogs from './blogs'
// import predictions from './predictions'
import TradingBlockRemote from "../services/TradingBlockRemote";
import { portfolioService} from '../services/services';
import createStreamingPlugin from './VuexStreamingPlugin'
import {AssetType} from "../domain/types";

let firstHiddenTab = 8;
if (window.isElite) {
  firstHiddenTab = 9;
}
$(document).ready(()=> {
  $('#myTabs > li:nth-child(' + firstHiddenTab + ')').hide();
  $('#myTabs > li:nth-child(' + (firstHiddenTab + 1) + ')').hide();
  $('#myTabs > li:nth-child(' + (firstHiddenTab + 2) + ')').hide();
});


let streamingPlugin = 'WebSocket' in window ? createStreamingPlugin ("wss://ws.tradingblock.com"): null;

const store = new Vuex.Store({
  plugins: [streamingPlugin],
  modules: {
    portfolio:portfolio,
    history:history,
    orders:orders,
    balance:balance,
    trade: trade
    //blogs:blogs,
    //predictions:predictions
  },
  state:{
    tb_logged: false,
    tb_logging: false,
    tb_tried: false,
    tb_login_error: null,
    tb_choosed_subaccount: false,
    tb_agree: false,
    tb_inited: false,
    tb_username: '',


    toolboxes_tab: '',

    screener_page: {},

    current_symbol: '',

    realtime_data: null,
    loaded: false,
    loading: false,
    error: false
  },
  mutations:{

    selectSymbol(state, payload){
      state.current_symbol = payload;
    },
    setLoading(state){
      state.loading = true;
      state.error = null;
      state.loaded = false;
    },
    setLoaded(state, payload){
      state.loading = false;
      state.error = null;
      state.loaded = true;
      state.realtime_data = payload;
    },
    setError(state, payload){
      state.loading = false;
      state.error = payload;
      state.loaded = false;
    },
    loadBlogs(state, payload){

    },
    setTab(state, payload){
      state.toolboxes_tab = payload;
    },
    setScreenerPage(state, payload){
      state.screener_page = payload;
    },

    TB_WS_ORDER_UPDATE(state, payload) {
      console.log('TB_WS_ORDER_UPDATE' + payload)
    },
    TB_WS_OPEN(state, payload) {
      console.log('TB_WS_OPENED')
    },
    TB_WS_CLOSE(state, payload) {
      console.log('TB_WS_OPENED')
    },
    TB_WS_ERROR(state,  payload) {
      console.log('TB_WS_ERROR')
    },
    QUOTES_SUBSCRIBE(state,  payload) {
      console.log('QUOTE_SUBSCRIBE')
    },
    QUOTES_UNSUBSCRIBE(state,  payload) {
      console.log('QUOTE_UNSUBSCRIBE')
    },
    ORDERS_SUBSCRIBE(state, payload) {
      console.log('ORDERS_SUBSCRIBE')
    },
    ORDERS_UNSUBSCRIBE(state, payload) {
      console.log('ORDERS_UNSUBSCRIBE')
    },
    TB_CHOOSED_SUBACCOUNT(state, payload) {
      console.log('TB_CHOOSED_SUBACCOUNT')
      state.tb_choosed_subaccount = true;
      $('#myTabs > li:nth-child(' + firstHiddenTab + ')').show();
      $('#myTabs > li:nth-child(' + (firstHiddenTab + 1) + ')').show();
      $('#myTabs > li:nth-child(' + (firstHiddenTab + 2) + ')').show();
    },

    TB_LOGIN(state, payload){
      state.tb_logged = true;
      state.tb_tried = false;
      state.tb_username = getCookie('USERNAME')
    },
    TB_LOGOUT(state, payload) {
      state.tb_logged = false;
      state.tb_tried = false;
      state.tb_choosed_subaccount = false;
      $('#myTabs > li:nth-child(' + (firstHiddenTab) + ')').hide();
      $('#myTabs > li:nth-child(' + (firstHiddenTab + 1) + ')').hide();
      $('#myTabs > li:nth-child(' + (firstHiddenTab + 2) + ')').hide();

      state.tb_username = '';

    }


  },
  actions: {
    chooseSubaccount({state, commit}, payload){
      TradingBlockRemote.SetSubAccount(payload);
      commit('TB_CHOOSED_SUBACCOUNT');
    },
    agreeTb(){
      TradingBlockRemote.setAgreement();
      state.tb_agree = true;
    },
    authTbCheck({state, commit}, payload){
      setTimeout(()=>{
        if (!TradingBlockRemote.needAgreement()){
          state.tb_agree = true;
        }
        if (TradingBlockRemote.authenticated){
          state.logged = true;
          commit('TB_LOGIN')
        }
        state.tb_inited = true;
      }, 1000);
    },
    async LoginTB({state, commit, dispatch},  payload){
      state.tb_logging = true;
      try {
        var res = await TradingBlockRemote.login(payload.username, payload.password, payload.live);
        state.tb_login_error = null;

        commit('TB_LOGIN');
      } catch (e) {
        state.tb_tried = true;
        state.tb_login_error = e;
      }
      state.tb_logging = false;

    },
    async LogoutTB({state, commit, dispatch},  payload){

      await TradingBlockRemote.logout();
      commit('TB_LOGOUT');
    },
    TB_WS_QUOTE ({state, commit, dispatch},  payload) {
      console.log('TB_WS_QUOTE' + payload)
      dispatch('portfolio/updateRealtimeBySymbol', payload);
    },
    setPage({state, commit}, payload){
      commit('setTab', payload.tab);
      if (['portfolio', 'screener', 'calculator'].indexOf(payload.tab) < 0) {
        commit('history/invalidate');
      }
      if (payload.tab === 'screener' && payload.subpage){
        commit('setScreenerPage', payload.subpage);
      }
      if (payload.tab === 'portfolio' && !payload.subpage)
        commit('portfolio/selectEditSymbol', null);
    },

      async SHOW_TRADE_WINDOW({state, dispatch, commit}, payload){
          if (state.tb_choosed_subaccount) {

              if (payload.Legs[0].AssetType===AssetType.Option ){
                if (!payload.RealtimeData) {
                  await dispatch('loadSymbol', payload.UnderlyingSymbol);
                } else {
                    commit('setLoaded', {LastTrade: payload.RealtimeData.ActualPricePerShare});
                }
              }
              await dispatch('trade/SET_ORDER', payload);
              state.trade.show_window = true;
          }
      },
    async loadSftSymbol({dispatch,state}){
      await dispatch('loadSymbol', $('#SymbolBox').val())
    },
    async loadSymbol({state, commit}, payload){

      commit('selectSymbol', payload);
      commit('setLoading');

      const quotes = await portfolioService.GetQuote(payload);
      if (!quotes || !quotes.Symbol) throw new Error("no quotes found for  " + payload);

      commit('setLoaded', quotes);
    }
  },
  getters:{
    isPortfolioTab(state){
      return state.toolboxes_tab === 'portfolio';
    },
    isScreenerTab(state){
      return state.toolboxes_tab === 'screener';
    },
    isCalculatorTab(state){
      return state.toolboxes_tab === 'calculator';
    },
    isFuturesTab(state){
      return state.toolboxes_tab === 'futures';
    }


  }
});

store.dispatch('authTbCheck');

export default store
